import context from './context'

export const csrfInterceptor = (config) => {
  config.headers['X-CSRF-TOKEN'] = context.csrfToken
  return config
}

export const unauthorizedInterceptor = (response) => {
  if (response.status === 401) {
    return Promise.reject({ redirect_uri: response.data?.redirect_uri })
  }
  return response
}
